import { Component, HostListener } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { CourseLectureStatus } from '../../shared/base/course-lecture-status';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { SelectQuestion } from '../../shared/dynamic-form/shared/question-select';
import { TextAreaQuestion } from '../../shared/dynamic-form/shared/question-textarea';
import { TextboxQuestion } from '../../shared/dynamic-form/shared/question-textbox';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Course } from '../shared/course';
import { MESSAGE_ADD_COURSE_SUCCESS } from '../shared/course-message';
import { CourseService } from '../shared/course.service';

@Component({
  selector: 'app-course-add-button',
  template: '<ng-content></ng-content>'
})
export class CourseAddButtonComponent extends DialogButtonBase {
  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: CourseService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions);
  }

  async onSubmit(value: Course): Promise<any> {
    try {
      await this.service.create(value);
      this.closeDialog();
      this.openSnackBar(MESSAGE_ADD_COURSE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private get title(): string {
    return '강좌 생성';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new TextboxQuestion({
        key: 'name',
        label: '제목',
        required: true
      }),
      new SelectQuestion({
        key: 'status',
        label: '상태',
        required: true,
      }, CourseLectureStatus.getOptions(CourseLectureStatus.Status.INPROGRESS)),
      new TextboxQuestion({
        key: 'slackUrl',
        label: 'slack url'
      }),
      new TextAreaQuestion({
        key: 'description',
        label: '간략한 설명'
      })
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-add-button/course-add-button.component.ts